import Cookies from "js-cookie";
import { constant } from "../constant";
import { adminAxios } from "../api/index"; 

export const UserLogin = async (data) => {
  const LoginURL = "Auth/login";
  try {
    const response = await adminAxios.post(LoginURL, data);
    return response;
  } catch (err) {
    return err?.response?.data?.message;
  }
};

export const GetUserByToken = async () => {
  const GetUserURL = "Auth/user";
  try {
    const response = await adminAxios.get(GetUserURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    console.log(response);
    
    Cookies.set("isCustomCall", response?.data?.user?.isCustomCall);
    Cookies.set("userType", response.data.user.UserType);
    Cookies.set("UserID", response.data.user.UserID);
    Cookies.set("CompanyId", response.data.user.CompanyID);
    Cookies.set("DepId", response.data.user.DepId);
    Cookies.set("userName", response.data.user.Username);
    Cookies.set("userPassword", response.data.user.Password);
    Cookies.set("resetToken", response.data.user.TokenResetAllowed);
    Cookies.set("isServiceEnable", response.data.user.isServiceEnable);
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAdminDashboard = () => {
  const CompanyId = Cookies.get("CompanyId");
  const GetDashboardURL = `Dashboard/dashBoard/${CompanyId}`;
  try {
    const response = adminAxios.get(GetDashboardURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllCounter = () => {
  const GetAllCounterURL = `counter/${Cookies.get("CompanyId")}`;

  try {
    const response = adminAxios.get(GetAllCounterURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const CreateCounterAPI = (data) => {
  const CreateCounterURL = "counter/create";
  try {
    const response = adminAxios.post(CreateCounterURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateCounterAPI = async (data, counterId) => {
  if (!counterId) return;
  const UpdateCounterURL = `counter/update/${counterId}`;
  try {
    const response = await adminAxios.put(UpdateCounterURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllDepartment = () => {
  const GetAllDepartmentURL = `Department/web/all/${Cookies.get("CompanyId")}`;
  try {
    const response = adminAxios.get(GetAllDepartmentURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const CreateDepartmentAPI = (data) => {
  const CreateDepartmentURL = "Department/create";
  try {
    const response = adminAxios.post(CreateDepartmentURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateDepartmentAPI = async (data, DepId) => {
  const UpdateDepartmentURL = `Department/update/${DepId}`;
  try {
    const response = await adminAxios.put(UpdateDepartmentURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllUser = () => {
  const GetAllUserURL = `auth/users/${Cookies.get("CompanyId")}`;
  try {
    const response = adminAxios.get(GetAllUserURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const CreateUserAPI = (data) => {
  const CreateUserURL = "auth/create";
  try {
    const response = adminAxios.post(CreateUserURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateUserAPI = async (data, UserId, mapArry) => {
  if (!UserId) return;
  const UpdateUserURL = `Auth/update/${UserId}`;
  try {
    const response = await adminAxios.put(UpdateUserURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });

    if (response.data.status === "success") {
      await UserMap(mapArry, UserId);
    }
    return response;
  } catch (err) {
    return err;
  }
};

export const UploadImage = async (data) => {
  const UploadImageURL = constant.image_upload_url;
  try {
    const response = await adminAxios.post(UploadImageURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UploadVedio = async (data) => {
  const UploadVedioURL = constant.vedio_upload_url;
  try {
    const response = await adminAxios.post(UploadVedioURL, data);
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllAdvertisement = () => {
  const GetAllAdvertisementURL = `advertisement/company/${Cookies.get("CompanyId")}`;
  try {
    const response = adminAxios.get(GetAllAdvertisementURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const CreateAdvertisementAPI = (data) => {
  const CreateAdvertisementURL = "advertisement/create";
  try {
    const response = adminAxios.post(CreateAdvertisementURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateAdvertisementAPI = async (data, AdvId) => {
  if (!AdvId) return;
  const UpdateAdvertisementURL = `advertisement/update/${AdvId}`;
  try {
    const response = await adminAxios.put(UpdateAdvertisementURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetCompanySettings = async () => {
  const CompanyId = Cookies.get("CompanyId");
  const UserId = Cookies.get("UserID");
  try {
    const response = await adminAxios.get('company/companySettings', {
      params: {
        CompanyId,
        UserId
      },
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateCompanySettings = async (data) => {
  const CompanyId = Cookies.get("CompanyId");
  const UpdateCompanySettingsURL = `Company/companysettings/${CompanyId}`;
  try {
    const response = await adminAxios.put(UpdateCompanySettingsURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllDetailReport = (startDate, endDate, pageNumber, pageSize, searchParam) => {
  const CompanyId = Cookies.get("CompanyId");
  const GetAllDetailReportURL = `token/report/tokenDetail/${CompanyId}?startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchParam=${searchParam}`;

  try {
    const response = adminAxios.get(GetAllDetailReportURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetAllSummaryReport = (date) => {
  const CompanyId = Cookies.get("CompanyId");
  const GetAllSummaryReportURL = `Token/summary/${CompanyId}?date=${date}`;

  try {
    const response = adminAxios.get(GetAllSummaryReportURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UserMap = async (Data, UserId) => {
  if (!UserId) return;
  const UserMapURL = `Auth/usermap/${UserId}`;
  try {   
    const response = await adminAxios.post(
      UserMapURL,
      Data, 
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("userToken")}`,
        },
      }
    );
    return response;
  } catch (err) {
   
    throw err;
  }
};

export const GetAllSevice = () => {
  const GetAllSeviceURL = `service/${Cookies.get("CompanyId")}`;
  try {
    const response = adminAxios.get(GetAllSeviceURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const CreateServiceAPI = (data) => {
  const CreateServiceURL = "service/create";
  try {
    const response = adminAxios.post(CreateServiceURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateServiceAPI = async (data, SerID) => {
  if (!SerID) return;
  const UpdateServiceAPIURL = `Service/update/${SerID}`;
  try {
    const response = await adminAxios.put(UpdateServiceAPIURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};